// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607071104/js/" + chunkId + "." + {"44":"b1e1457c","225":"a2984832","481":"f3f2eeda","486":"b4cfd9c2","770":"3449cd57"}[chunkId] + ".0.8667604365882158.chunk.js";
};